import React from "react";

//material UI
import { Grid, Typography } from "@mui/material";

//imagens
import MyGenderLogo from "../../images/mygender-logo__small.svg";

//booklets
import BookIcon from "../../images/book_icon.svg";

export default function ResourcesScreen() {
  return (
    <Grid container spacing={2} sx={{ minHeight: "100vh" }}>
      <Grid item xs></Grid>
      <Grid item xs={10} zeroMinWidth>
        <Grid
          container
          spacing={2}
          sx={{
            marginBottom: {
              xs: "25%",
              sm: "15%",
              md: "10%",
              lg: "5%",
              xl: "5%",
            },
          }}
        >
          <Grid item xs={12} sx={{ textAlign: "right", marginTop: "6vh" }}>
            <img
              src={MyGenderLogo}
              className="mygender-logo__about"
              alt="Logo oficial do projeto de investigação MyGender da Universidade de Coimbra"
            ></img>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={2} sx={{ textAlign: "right" }}>
                <img src={BookIcon} alt="Icon com dois livros"></img>
              </Grid>
              <Grid item xs={10}>
                <Typography
                  color={"#000000"}
                  fontSize={{
                    xs: "2rem",
                    sm: "2rem",
                    md: "2rem",
                    lg: "3rem",
                    xl: "3rem",
                  }}
                  fontStyle={"normal"}
                  fontWeight={700}
                  fontFamily={"Inter, Helvetica, sans-serif"}
                  lineHeight={"100%"}
                >
                  Recursos
                </Typography>
                <Typography
                  color={"#000000"}
                  fontSize={{
                    xs: "0.87rem",
                    sm: "0.87rem",
                    md: "0.87rem",
                    lg: "1rem",
                    xl: "1rem",
                  }}
                  fontStyle={"normal"}
                  fontWeight={400}
                  fontFamily={"Inter, Helvetica, sans-serif"}
                  lineHeight={{
                    xs: "1.25rem",
                    sm: "1.25rem",
                    md: "1.25rem",
                    lg: "2rem",
                    xl: "2rem",
                  }}
                >
                  Clica na imagem para descarregar em pdf
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={6}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <a
                  href="https://mygender.uc.pt/wp-content/uploads/2022/09/Booklet_MyGender_Igualdade-de-Genero.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/booklet1.svg"}
                    className="container"
                    alt="Booklet MyGender - Igualdade de Género"
                  ></img>
                </a>
              </Grid>
              <Grid
                item
                xs={6}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <a
                  href="https://mygender.uc.pt/wp-content/uploads/2023/06/PT-Booklet-MyGender-Sexualidades-_.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/booklet2.svg"}
                    className="container"
                    alt="Booklet MyGender - Sexualidades"
                  ></img>
                </a>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={6}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <a
                  href="https://mygender.uc.pt/wp-content/uploads/2022/04/Booklet-MyGender-Privacidade-PT.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/booklet3.svg"}
                    className="container"
                    alt="Booklet MyGender - Privacidade & Educação para os Media"
                  ></img>
                </a>
              </Grid>
              <Grid
                item
                xs={6}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <a
                  href="https://mygender.uc.pt/wp-content/uploads/2022/05/Guia-MyGender_Tempo-de-ecra_final.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/booklet4.svg"}
                    className="container"
                    alt="Booklet MyGender - Tempo de Ecrã"
                  ></img>
                </a>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Grid container spacing={0}>
                  <Grid
                    item
                    xs={12}
                    zeroMinWidth
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <a
                      href="https://mygender.uc.pt/wp-content/uploads/2022/09/MyGenderToolkit_PT_.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={process.env.PUBLIC_URL + "/images/booklet5.svg"}
                        className="container"
                        alt="MyGender Toolkit"
                      ></img>
                    </a>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    zeroMinWidth
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <a
                      href="https://mygender.uc.pt/wp-content/uploads/2022/09/MyGenderToolkit_PT_.pdf"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={process.env.PUBLIC_URL + "/images/booklet6.svg"}
                        className="container"
                        alt="DevGender Toolkit"
                      ></img>
                    </a>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={6}
                zeroMinWidth
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <a
                  href="https://mygender.uc.pt/wp-content/uploads/2022/11/MyGender-Data-Analysis-Report-2022-PT.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/booklet7.svg"}
                    className="container"
                    alt="Relatório de Análise de Dados - Projeto MyGender"
                  ></img>
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
